import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreateAddressModal from "../../UserProfile/UserAddress/CreateAddressModal";
import { listAddressAction } from "../../../redux/actions/User";
import {
  profileToCheckoutFields,
  savedAddressToCheckoutFields,
} from "../../../utils/addressHelpers";
import {
  checkoutCard,
  checkoutInput,
  checkoutLabel,
  checkoutSectionTitle,
} from "./checkoutUiClasses";

const PaymentInfo = ({ PaymentInfoData, setPaymentInfoData, format }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [ShowAddressModal, setShowAddressModal] = useState(false);
  const prefilledRef = useRef(null);

  const HandleinfoChange = (e) => {
    setPaymentInfoData({ ...PaymentInfoData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const key = user?._id || "guest";
    if (prefilledRef.current === key) return;

    let cancelled = false;

    const applyFields = (fields) => {
      if (!fields || cancelled) return;
      setPaymentInfoData((prev) => ({
        ...prev,
        ...fields,
      }));
      prefilledRef.current = key;
    };

    (async () => {
      if (user?._id) {
        const list = await dispatch(listAddressAction());
        if (cancelled) return;

        const fromProfile = profileToCheckoutFields(user, list?.[0]);
        const hasStructuredAddress =
          fromProfile.address && fromProfile.city && fromProfile.state && fromProfile.zip;

        if (hasStructuredAddress) {
          applyFields(fromProfile);
          return;
        }

        const raw = localStorage.getItem(`userAddress_${user._id}`);
        const fromStorage = raw ? savedAddressToCheckoutFields(JSON.parse(raw)) : null;
        applyFields({
          ...fromProfile,
          ...(fromStorage || {}),
        });
        return;
      }

      const raw = localStorage.getItem("guestAddress");
      if (!raw) return;
      applyFields(savedAddressToCheckoutFields(JSON.parse(raw)));
    })();

    return () => {
      cancelled = true;
    };
  }, [user, dispatch, setPaymentInfoData]);

  return (
    <div className={checkoutCard}>
      <h2 className={checkoutSectionTitle}>Delivery Details</h2>
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="your_name" className={checkoutLabel}>
              First Name*
            </label>
            <input
              type="text"
              id="your_name"
              name="fname"
              className={checkoutInput}
              placeholder="Your Name"
              value={PaymentInfoData.fname}
              onChange={HandleinfoChange}
              required
            />
          </div>
          <div>
            <label htmlFor="lname" className={checkoutLabel}>
              Last Name*
            </label>
            <input
              type="text"
              id="lname"
              className={checkoutInput}
              placeholder="Last Name"
              name="lname"
              value={PaymentInfoData.lname}
              onChange={HandleinfoChange}
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="your_email" className={checkoutLabel}>
              Email*
            </label>
            <input
              type="email"
              id="your_email"
              className={checkoutInput}
              placeholder="Example@gmail.com"
              name="email"
              value={PaymentInfoData.email}
              onChange={HandleinfoChange}
              required
            />
          </div>
          <div>
            <label htmlFor="your_phone" className={checkoutLabel}>
              Phone Number*
            </label>
            <input
              type="tel"
              id="your_phone"
              className={checkoutInput}
              placeholder="Your Phone Number"
              name="phoneNumber"
              value={PaymentInfoData.phoneNumber}
              onChange={HandleinfoChange}
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div>
            <label htmlFor="address" className={checkoutLabel}>
              Street Address*
            </label>
            <input
              type="text"
              id="address"
              className={checkoutInput}
              placeholder="Your Address"
              name="address"
              value={PaymentInfoData.address}
              onChange={HandleinfoChange}
              required
            />
          </div>
          <div>
            <label htmlFor="country" className={checkoutLabel}>
              Country*
            </label>
            <input
              type="text"
              id="country"
              className={checkoutInput}
              placeholder="Your country"
              name="country"
              value={PaymentInfoData.country}
              onChange={HandleinfoChange}
              required
            />
          </div>
          <div>
            <label htmlFor="city" className={checkoutLabel}>
              City*
            </label>
            <input
              type="text"
              id="city"
              className={checkoutInput}
              placeholder="Your city"
              name="city"
              value={PaymentInfoData.city}
              onChange={HandleinfoChange}
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label htmlFor="state" className={checkoutLabel}>
              State*
            </label>
            <input
              type="text"
              id="state"
              className={checkoutInput}
              placeholder="Your state"
              name="state"
              value={PaymentInfoData.state}
              onChange={HandleinfoChange}
              required
            />
          </div>
          <div>
            <label htmlFor="zip" className={checkoutLabel}>
              Postal_code*
            </label>
            <input
              type="number"
              id="zip"
              className={checkoutInput}
              placeholder="Your zip"
              name="zip"
              value={PaymentInfoData.zip}
              onChange={HandleinfoChange}
              required
            />
          </div>
        </div>
      </div>

      {ShowAddressModal && (
        <CreateAddressModal setHideModal={setShowAddressModal} />
      )}
    </div>
  );
};

export default PaymentInfo;
